<template>
  <div>
    <div class="book-detail">
      <div class="left">
        <BookCover
          :source="getImage"
          :type="book.dmcode"
          :book="book"
          :showActions="false"
        />
      </div>
      <div class="info">
        <h4 @click="toDetail(book)">
          <span v-html="book.title"></span>
          <img
            class="ml10"
            v-if="$methods.isLibrary(book.libraryCustomerCode)"
            :src="iconGc"
          />
        </h4>
        <p v-html="book.titleCn" />
        <div class="detail">
          <DetailLine title="作者信息" :content="book.authorinfo" block html />
          <p>
            <DetailLine title="出版社" :content="getPublisherInfo(book)" html />
            <DetailLine title="出版时间" :content="book.publishyear" />
            <DetailLine title="版权年" :content="book.copyrightYear" />
          </p>
          <DetailLine title="ISBN" block show>
            <a v-html="book.isbn" href="javascript:void(0)" @click="toDetail(book)"></a>
          </DetailLine>
          <DetailLine title="丛书" :content="book.seriestitle" block>
            <template v-if="book.seriesno">,{{ book.seriesno }}</template>
          </DetailLine>
          <p>
            <DetailLine title="装帧" :content="book.binding" />
            <DetailLine title="页码" :content="book.pagesInfo" />
            <DetailLine title="语种" :content="book.language" />
            <DetailLine title="内容类型" :content="book.contenttype" />
          </p>
          <DetailLine
            title="收藏时间"
            :content="book.userfavorite.recordlist[0].createtime"
            block
            v-if="isFavorite && book.userfavorite"
          />
          <p class="available" v-if="!isFavorite">
            有
            <span>{{ bookVersionCount }}</span>
            个版本可选
          </p>
        </div>
        <div class="recommend-info" v-if="!isFavorite">
          <p>
            <DetailLine title="推荐人" :content="book.likeinfo.userName" />
            <DetailLine title="推荐时间" :content="book.likeinfo.starDate" />
          </p>
          <DetailLine title="推荐理由" :content="book.likeinfo.reason" block>
            <el-button type="text" class="change-reason" @click="changeReason(book)">
              <i class="edit" />
              <span>修改推荐理由</span>
            </el-button>
          </DetailLine>
        </div>
      </div>
    </div>
    <RecommendDialog
      :book="editingBook"
      :showDialog="showRecommend"
      editing
      @close="showRecommend = false"
    />
  </div>
</template>

<script>
import urlSet from '@/requests/url'
import tableMixin from '@/mixins/table.js'
import BookCover from '@/components/BookCover.vue'
import RecommendDialog from './RecommendDialog.vue'

export default {
  name: 'BookListItem',
  mixins: [tableMixin],
  props: {
    book: Object,
    isFavorite: Boolean,
  },
  data() {
    return {
      noImg: require('images/no-image.png'),
      showRecommend: false,
      editingBook: {},
      iconGc: require('images/icon-gc.png'),
    }
  },
  computed: {
    bookVersionCount() {
      const count = this.lodash.get(this.book, 'relatdbooks.relatedResult.recordcount', 0)
      if (!count) return count // 如果是0就直接返回
      return count - 1 // 否则减一后返回
    },
    getImage() {
      if (this.book.dbid === 'cnoa') {
        // 如果书目类型为古籍则使用专属URL
        return `http://oa.cxstar.cn/cn/profile/covers${this.book.coverruid}`
      }
      const id = this.book.coverruid
      if (!id) return this.noImg
      return id.substring(0, 4) === 'http'
        ? id
        : `${urlSet.fileUrl}/api/v1/fileredirect/file?ruid=${id}`
    },
    getSupplyOk() {
      if (this.book.main) {
        if (this.book.relatdbooks.supplyOk) {
          return '正常供货'
        } else {
          return '不可供货'
        }
      } else {
        if (this.book.supplyOk) {
          return '正常供货'
        } else {
          return '不可供货'
        }
      }
    },
    getSaleCount() {
      if (this.book.main) {
        if (this.book.relatdbooks.saleCount > 0) {
          return '有现货'
        } else {
          return '没有现货'
        }
      } else {
        if (this.book.saleCount > 0) {
          return '有现货'
        } else {
          return '没有现货'
        }
      }
    },
  },
  methods: {
    getPublisherInfo(book) {
      const publisher = book.publisher
      const brandName = book.publisherbrandname
      return `${publisher}${brandName ? `, ${brandName}` : ''}`
    },
    changeReason(book) {
      this.editingBook = book
      this.showRecommend = true
    },
    getVersionInfo(item) {
      const keys = ['versionStr', 'editionStr', 'binding', 'volumeNo']
      const filteredKeys = keys.filter((key) => item[key])
      const values = filteredKeys.map((key) => item[key])
      return values.join(',')
    },
    glIcon(prop, idx) {
      const val = this.book[prop]
      return val.length > 1 && idx < val.length - 1 ? ' ; ' : ''
    },
    disableButton(item) {
      const state = item.reviewState
      switch (state) {
        case 'manual_reject':
          return true
        case 'top_reject':
          return true
        case '7':
          return true
        case '9':
          return true
        default:
          return false
      }
    },
    getSeriesType(type) {
      if (type == '1987051001') {
        return '纸书'
      } else if (type == '1987052001') {
        return '电子书'
      } else if (type == '1987054001') {
        return '纸+电'
      } else if (type == '1987053001') {
        return '数据库电子书'
      } else {
        return '未知'
      }
    },
    showInfo(content) {
      if (!content && content !== 0) {
        return false
      } else {
        return true
      }
    },
    toPublisher(name, type) {
      if (type == 0) {
        this.$emit('defaultPublisher', name)
      }
      if (type == 1) {
        this.$emit('defaultSeries', name)
      }
      // const code = this.book.publishercustomercode
      // let url = this.$router.resolve({
      //   name: 'PublisherDetail',
      //   query: { customer: code }
      // });
      // window.open(url.href, '_blank')
    },
  },
  components: { BookCover, RecommendDialog },
}
</script>

<style lang="scss" scoped>
/deep/ .el-table__body {
  min-width: 100%;
}
/deep/ .el-table__header {
  min-width: 100%;
  .cell {
    font-weight: normal !important;
    font-size: 16px !important;
    color: #666 !important;
  }
}
.redColor {
  color: #f00;
}
.record {
  margin-top: 20px;
}
.isbn {
  a {
    color: #5689ca;
    cursor: pointer;
    text-decoration: underline;
    font-style: normal;
  }
}
.book-detail {
  display: flex;
  .left {
    // width: 140px;
    // min-width: 140px;
    .cover {
      position: relative;
      height: 200px;
      width: 200px;
      border-bottom: 1px solid #e1e1e1;
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      border: 1px solid #e1e1e1;
      img {
        display: inline-block;
        max-width: 100%;
        max-height: 100%;
        // box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        cursor: pointer;
      }
      .type {
        position: absolute;
        left: 0;
        bottom: 0px;
        padding: 5px 10px;
        color: #fff;
        background-color: $mainColor;
      }
    }
  }
  .info {
    flex: 1;
    word-break: break-all;
    margin: 0 20px;
    > * {
      margin-bottom: 10px;
    }
    h4 {
      font-size: 18px;
      cursor: pointer;
      &:hover {
        color: $mainColor;
      }
    }
    p {
      color: #666;
      font-size: 18px;
    }
    .available {
      font-size: 16px;
      line-height: 1.5rem;
      color: #333;
      span {
        color: #f00;
      }
    }
    .detail {
      .row {
        display: block;
        > div {
          display: inline-block;
          margin-right: 15px;
        }
      }
      div {
        line-height: 1.5rem;
        font-size: 16px;
        b {
          font-weight: normal;
          color: #333;
          &::after {
            content: '：';
          }
        }
        span {
          color: #666;
          label {
            color: #666;
          }
        }
        .link {
          color: $mainColor;
          text-decoration: underline;
          cursor: pointer;
        }
        .child-publisher {
          color: #666;
        }
      }
      .inline-row {
        display: inline-block;
        margin-right: 15px;
      }
    }
    .version {
      display: block;
    }
    .buttons {
      margin-top: 20px;
    }
  }
}
.tips {
  font-size: 14px;
  span {
    background: #f7f7f7;
    color: #2f8bd6;
    padding: 3px 10px;
    margin-right: 10px;
  }
}
.button-review {
  display: flex;
  .review-info {
    margin-left: 15px;
    display: flex;
    align-items: center;
    span {
      color: #f00;
      font-size: 13px;
    }
  }
}
.recommend-info {
  padding: 10px 20px;
  background: #f5f5f5;
  .change-reason {
    padding: 0;
    font-size: 16px;
    margin-left: 20px;
    > span {
      display: flex;
    }
    .edit {
      margin-right: 10px;
      display: inline-block;
      width: 16px;
      height: 16px;
      background-image: url('../assets/images/edit.png');
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
}
</style>
